const SectionTypes = [
  "about",
  "social",
  "video",
  "gallery",
  "testimonials",
  "cta",
  "apps",
  "payment",
  "reachout",
] as const;

export const SectionValues = [...SectionTypes];
